export const addHttpProtocol = (url: string) => {
  if (/^https?:\/\//.test(url)) {
    return url;
  }
  return `https://${url}`;
};
